
import { mdiRadioboxBlank, mdiRadioboxMarked } from "@mdi/js";

export default {
  filters: {
    capitalLetter(value) {
      return value[0].toUpperCase() + value.slice(1);
    },
  },
  props: {
    data: {
      type: Object,
    },
  },

  data() {
    return {
      mdiRadioboxBlank,
      mdiRadioboxMarked,

      selectedFilters: {
        gender: "",
        district: "",
      },
      nothing: "",
      openedTabs: [0],
    };
  },

  computed: {
    arrValues() {
      let arr = [];
      for (let i in this.data) {
        arr.push(i);
      }
      return arr;
    },
  },

  watch: {
    selectedFilters: {
      handler() {
        this.$emit("add", this.selectedFilters);
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    this.$root.$on("sidebar-reset", () => {
      this.selectedFilters = {
        gender: "",
        district: [],
      };
    });
  },

  methods: {},
};
